export interface WeeeFeedbackState {
  status:string;
  isLoading: boolean;
}

export const weeeFeedbackInitialState: WeeeFeedbackState = {
  status: '',
  isLoading: true,
};
